const Constants = {
  serverlink: process.env.REACT_APP_API_BASE || "https://casinoapi.magicmatter.net",
  timeout: 30000,
  PRICE_WITH_TVA: false,
};

export default Constants;
